import { useQuery } from '@tanstack/react-query';
import { CACHE_TIME } from '@hygge/shared';
import { getEmployee } from '@/lib/employees';
import { employeesKeys } from './use-employees';

/**
 * Hook to fetch a single employee by ID
 */
export function useEmployee(id: string) {
  return useQuery({
    queryKey: employeesKeys.detail(id),
    queryFn: () => getEmployee(id),
    staleTime: CACHE_TIME.DEFAULT,
    enabled: !!id,
  });
}

